import { TextField } from '@mui/material';

interface classicTextFieldProps {
    value: string;
    label: string;
    changeValueHandler: (
        e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => void;
}

export const ClassicTextField: React.FC<classicTextFieldProps> = ({
    value,
    label,
    changeValueHandler,
}) => {
    return (
        <TextField
            label={label}
            variant="standard"
            color="secondary"
            value={value}
            onChange={changeValueHandler}
            sx={{ width: { xs: '90%', md: '50%', lg: '30%' } }}
        />
    );
};
